module.exports = __webpack_public_path__ + "img/background-agen.43156bb9.jpg";